import { Box } from '@mui/material';

import { BackgroundImg } from 'common/components/Img';
import { ISkillDetailFragment } from 'graphql/types';
import { PortfolioItemContentBase } from 'user/components/PortfolioItemDrawer/PortfolioItemContentBase';
import { ReceivedCertificatePortfolioItemTable } from 'skill/components/ReceivedCertificatePortfolioItemTable';

export const SkillPortfolioItemContent = (
    props: React.ComponentProps<typeof PortfolioItemContentBase>
) => {
    const { portfolioItem } = props;
    const { id: portfolioItemId, user, relatedObject } = portfolioItem || {};

    const skill = relatedObject as ISkillDetailFragment;
    const headerImage = skill?.thumbnail?.url;

    return (
        <>
            {headerImage && (
                <BackgroundImg src={headerImage} sx={{ minHeight: '250px' }} />
            )}

            <PortfolioItemContentBase
                relatedObjectDescription={skill?.description || undefined}
                {...props}
            >
                <Box sx={{ pb: 6, pt: 2, px: 4 }}>
                    <ReceivedCertificatePortfolioItemTable
                        portfolioItemId={portfolioItemId}
                        user={user}
                    />
                </Box>
            </PortfolioItemContentBase>
        </>
    );
};
